import { Log } from 'ng2-logger';
import { all, put, takeEvery } from 'redux-saga/effects';
import { HelpdeskService } from '../../api/helpdesk-service';
import Translator from '../../core/i18n';
import * as helpDeskActions from '../actions/helpdesk';
import * as constants from '../constants/helpdesk';
import * as coreActions from '../actions/core';

const T = Translator.create();
const _logger = Log.create('Helpdesk Saga');
const _helpdeskService = new HelpdeskService();

function* getHelpdeskMessage(params: any): any {
    try {
        const responseMessage = yield _helpdeskService
            .RequestGetMessageAsync(params)
            .then((responseMessageData: Response) => {
                return responseMessageData.json();
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(helpDeskActions.setHelpDeskMessage(responseMessage));
    } catch (error: any) {
        _logger.error('Calling message error', error);
    }
    return null;
}
function* getHelpDeskList(params: any): any {
    try {
        const responseList = yield _helpdeskService
            .RequestGetListAsync(params)
            .then((responseListData: Response) => {
                return responseListData.json();
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });
        const totalCount = (responseList && responseList.length > 0) ? responseList[0].count : 0;
        yield put(helpDeskActions.setHelpdeskList(responseList, params.page, params.take, totalCount));
    } catch (error: any) {
        _logger.error('Calling list ', error);
    }
    return null;
}

function* setHelpdeskAssignedUser(params: any): any {
    try {
        const responseMessage = yield _helpdeskService
            .RequestGetAssignedUserAsync(params)
            .then((responseMessageData: Response) => {
                return responseMessageData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });
        _logger.data('assigned user sagas response', responseMessage);
        yield put(helpDeskActions.setHelpdeskAssignedUser(responseMessage));
    } catch (error: any) {
        _logger.error('assigned user sagas error ', error);
    }
    return null;
}
//_______________________________________________________________________________________
function* postHelpDeskCreate(params: any): any {
    try {
        const responseCreate = yield _helpdeskService
            .RequestPostCreateAsync(params)
            .then((responseCreateData: Response) => {
                return responseCreateData.json();
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });

        yield put(helpDeskActions.setHelpdeskCreate(responseCreate));
        params.callback();
    } catch (error: any) {
        _logger.error('Calling create ', error);
    }
    return null;
}

export function* watchGetHelpDeskMessage() {
    yield takeEvery(constants.actions.GET_HELPDESK_MESSAGE, getHelpdeskMessage);
    return null;
}
export function* watchPostHelpDeskCreate() {
    yield takeEvery(constants.actions.POST_HELPDESK_CREATE, postHelpDeskCreate);
    return null;
}
export function* watchGetHelpDeskList() {
    yield takeEvery(constants.actions.GET_HELPDESK_LIST, getHelpDeskList);
    return null;
}

export function* watchSetHelpDeskAssignedUser() {
    yield takeEvery(constants.actions.SET_HELPDESK_ASSIGNEDUSER, setHelpdeskAssignedUser);
    return null;
}
//#endregion "Add Assignment Activity End Saga"

export function* HelpdeskSagas() {
    yield all([watchGetHelpDeskMessage(), watchPostHelpDeskCreate(), watchGetHelpDeskList(), watchSetHelpDeskAssignedUser()]);
}
